// extracted by mini-css-extract-plugin
export default {"mainContainer":"YourEmployer_mainContainer__OLt8o","checkboxLabel":"YourEmployer_checkboxLabel__3TEMd","skeletonLoadingAnimation":"YourEmployer_skeletonLoadingAnimation__qrTln"};